import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getQuery } from '@src/common/url';
/**
 * for this page
 */
import Content from './content';
import Header from './CallUpHead';

import { QQShare } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';

const from = getQuery('from') || '';
const liveId = getQuery('liveid') || '';
const isCallClientLiveVideo = !!(from === 'qqlive' && liveId);

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    componentDidMount = () => {
        const {
            content: { base62Id },
        } = this.props;

        if (isCallClientLiveVideo) {
            // 页面统计
            h5PageCount([
                {
                    datatype: 'newsappsns',
                    behavior: 'page',
                    type: 'survey',
                    other: {
                        id: `livesurvey_${base62Id}`,
                        ref: encodeURIComponent(document.referrer),
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        } else {
            // 页面统计
            h5PageCount([
                {
                    datatype: 'newsappsns',
                    behavior: 'page',
                    type: 'survey',
                    other: {
                        id: `survey_${base62Id}`,
                        ref: encodeURIComponent(document.referrer),
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }
    };

    render() {
        const { content } = this.props;

        const { surveyData, id, fhhAccountDetail, headKeyword, base62Id } = content;
        const contentData = {
            surveyData,
            fhhAccountDetail,
            base62Id,
        };

        // console.log(surveyData);
        const qqShareCofig = {
            title: (surveyData && surveyData.surveyinfo && surveyData.surveyinfo.title && `${surveyData && surveyData.surveyinfo && surveyData.surveyinfo.title}-凤凰小调查`) || '凤凰小调查',
            img: 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: (surveyData && surveyData.surveyinfo && surveyData.surveyinfo.leadtxt) || '',
        };

        return (
            <Fragment>
                {surveyData && surveyData.surveyinfo && surveyData.surveyinfo.isactive === '1' ? (
                    <div className={styles.layout}>
                        <Header id={base62Id} keyword={headKeyword} isCallClientLiveVideo={isCallClientLiveVideo} liveId={liveId} />
                        <Content content={contentData} id={id} isCallClientLiveVideo={isCallClientLiveVideo} liveId={liveId} />
                        <QQShare content={qqShareCofig} />
                    </div>
                ) : (
                    <div className={styles.request_no}>抱歉，该调查不存在，感谢您的关注!</div>
                )}
            </Fragment>
        );
    }
}

export default Layout;
